export default __webpack_public_path__ + "static/media/Silber.92f0ab56.png";